// CsvUtils.js - Utilitário para geração e exportação de arquivos CSV

class CsvUtils {
    /**
     * Converte dados em formato CSV
     * @param {Array<Array<string>>} dados - Array de arrays com os dados (lista de listas de strings)
     * @param {Array<string>} colunas - Array de strings com os títulos das colunas (cabeçalho)
     * @param {Object} opcoes - Opções de configuração
     * @returns {string} String CSV
     */
    static converterParaCsv(dados = [], colunas = [], opcoes = {}) {
        const opcoesDefault = {
            separador: ';',
            delimiter: '"',
            incluirCabecalho: true,
            quebralinha: '\n',
            ...opcoes
        };

        const linhas = [];

        // Adiciona cabeçalho se solicitado
        if (opcoesDefault.incluirCabecalho && colunas.length > 0) {
            const cabecalho = colunas.map(coluna => 
                this.escaparCampo(String(coluna), opcoesDefault)
            );
            linhas.push(cabecalho.join(opcoesDefault.separador));
        }

        // Processa cada linha de dados
        dados.forEach(linha => {
            // Se a linha não é array, converte para array
            const linhaArray = Array.isArray(linha) ? linha : [linha];
            
            const linhaCsv = linhaArray.map(valor => {
                // Formata e escapa cada valor
                const valorFormatado = this.formatarValorCsv(valor);
                return this.escaparCampo(valorFormatado, opcoesDefault);
            });

            linhas.push(linhaCsv.join(opcoesDefault.separador));
        });

        return linhas.join(opcoesDefault.quebralinha);
    }

    /**
     * Formata valores para CSV
     * @param {*} valor - Valor a ser formatado
     * @returns {string} Valor formatado
     */
    static formatarValorCsv(valor) {
        // Trata valores nulos ou undefined
        if (valor === null || valor === undefined) {
            return '';
        }

        // Converte para string
        valor = String(valor);

        // Remove tags HTML se houver
        valor = valor.replace(/<[^>]*>/g, '');

        return valor;
    }

    /**
     * Escapa campos CSV adequadamente
     * @param {string} campo - Campo a ser escapado
     * @param {Object} opcoes - Opções de configuração
     * @returns {string} Campo escapado
     */
    static escaparCampo(campo, opcoes) {
        if (typeof campo !== 'string') {
            campo = String(campo);
        }

        // Se contém separador, delimiter ou quebra de linha, envolve com delimiters
        if (campo.includes(opcoes.separador) || 
            campo.includes(opcoes.delimiter) || 
            campo.includes('\n') || 
            campo.includes('\r')) {
            
            // Duplica os delimiters internos
            campo = campo.replace(new RegExp(opcoes.delimiter, 'g'), opcoes.delimiter + opcoes.delimiter);
            
            // Envolve com delimiters
            return opcoes.delimiter + campo + opcoes.delimiter;
        }

        return campo;
    }

    /**
     * Baixa um arquivo CSV
     * @param {string} conteudoCsv - Conteúdo CSV
     * @param {string} nomeArquivo - Nome do arquivo
     */
    static baixarCsv(conteudoCsv, nomeArquivo = 'dados.csv') {
        // Adiciona BOM para garantir encoding UTF-8 correto
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + conteudoCsv], { type: 'text/csv;charset=utf-8;' });
        
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.setAttribute('href', url);
        link.setAttribute('download', nomeArquivo);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
          // Limpa o URL do objeto
        URL.revokeObjectURL(url);
    }

    /**
     * Gera CSV simples com dados como lista de listas e colunas como cabeçalho
     * @param {Array<Array<string>>} dados - Lista de listas de strings (linhas e colunas)
     * @param {Array<string>} colunas - Array de strings com os títulos das colunas
     * @param {string} nomeArquivo - Nome do arquivo a ser baixado
     * @param {Object} opcoes - Opções de configuração
     */
    static gerarCsv(dados, colunas, nomeArquivo = 'dados.csv', opcoes = {}) {
        const csvContent = this.converterParaCsv(dados, colunas, opcoes);
        this.baixarCsv(csvContent, nomeArquivo);
    }
}

export default CsvUtils;
